import { REFERRAL_REQUEST, REFERRAL_SUCCESS, REFERRAL_FAILURE } from '../actions/types';

const initialState = {
  loading: false,
  error: undefined,
};

export default function referralReducer(state = initialState, action = {}) {
  switch (action.type) {
    case REFERRAL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REFERRAL_SUCCESS: {
      const {
        is_stepped: isStepped,
        referrer_name: referrerName,
        referral_code: code,
        invitee_steps: inviteeSteps,
        invitee_amount: inviteeAmount,
        reward_expiration_days: rewardExpirationDays,
        currency_symbol: currencySymbol,
      } = action.payload;

      return {
        ...state,
        loading: false,
        referrerName,
        code,
        isStepped,
        inviteeSteps: isStepped ? inviteeSteps : undefined,
        inviteeAmount,
        rewardExpirationDays,
        currencySymbol,
        error: undefined,
      };
    }
    case REFERRAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          status: action.status,
        },
      };
    default:
      return state;
  }
}
